var styles = {"box":"TimerBanner_box_ltwea_1","timer":"TimerBanner_timer_ltwea_12","timer-seconds":"TimerBanner_timer-seconds_ltwea_16","timer-col":"TimerBanner_timer-col_ltwea_19","description":"TimerBanner_description_ltwea_79","lg":"TimerBanner_lg_ltwea_89"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
